import { gql } from '@apollo/client';

export * from './assetCreateOauth.mutation.generated';

export const ASSET_CREATE_OAUTH = gql`
  mutation assetCreateOauth($softwareEscrowId: ID!, $integrationId: ID!, $assetsParams: [AssetCreateOauthParams!]!) {
    assetCreateOauth(
      input: { softwareEscrowId: $softwareEscrowId, integrationId: $integrationId, assetsParams: $assetsParams }
    ) {
      success
      errors
      assets {
        id
        softwareEscrow {
          id
          depositorConfigured
        }
      }
    }
  }
`;
